import React from 'react';
import { PropTypes } from 'prop-types';
import AlertDialog from '../../../components/custom/AlertDialog';

const ConfirmDeleteModal = ({
  confirmHandler, dismissHandler, modal: { open, ids },
}) => {
  const modalConfirmHandler = () => {
    confirmHandler(ids);
  };

  const modalDismissHandler = () => {
    dismissHandler();
  };

  return (
    <AlertDialog
      title="Delete selected Ala Agreements"
      open={!!open}
      confirmTitle="Delete"
      onConfirmation={modalConfirmHandler}
      onDismiss={modalDismissHandler}
    />
  );
};

ConfirmDeleteModal.propTypes = {
  modal: PropTypes.shape({
    open: PropTypes.bool,
    ids: PropTypes.arrayOf(
      PropTypes.number,
    ),
  }),
  confirmHandler: PropTypes.func,
  dismissHandler: PropTypes.func,
};

export default ConfirmDeleteModal;
